module.exports = __webpack_public_path__ + "static/media/edmonton.9308e360.webp";